import KeyPair from "protico-encryption/dist/KeyPair";
import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from ".";
import { saveUserProfileInfo } from "../store/reducers/profile";
import useBasicProfile from "./useBasicProfile";

const useRestorePubkey = () => {
  const { privateKey } = useAppSelector((state) => state.keys);
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { basicProfile: userProfile, refetch } =
    useBasicProfile(currentAddress);
  const dispatch = useAppDispatch();
  const userKeypair = useMemo(() => {
    if (!privateKey) return undefined;
    const Uint8PrivateKey = new Uint8Array(Buffer.from(privateKey, "base64"));
    return new KeyPair(currentAddress).fromPrivate(Uint8PrivateKey);
  }, [privateKey, currentAddress]);
  useEffect(() => {
    if (!userKeypair) return;
    // because this pubkey generate from local private key,
    // so I can say this is correct real pubkey
    const realPubkey = Buffer.from(userKeypair.get().public!).toString(
      "base64"
    );
    if (!userProfile?.public_key || userProfile.public_key !== realPubkey) {
      // user's pubkey somehow broken
      console.log("start restoring pubkey: ", realPubkey);
      dispatch(
        saveUserProfileInfo(
          {
            public_key: realPubkey,
          },
          refetch
        )
      );
    }
  }, [userKeypair, userProfile]);
};
export default useRestorePubkey;
